import React from "react";
import { translate } from "../../utils/i18n";

function OpenInGmap({ selectedDevice, useArrowIcon, addClassName, hideIcon }) {
  if (selectedDevice && "geo" in selectedDevice && selectedDevice.geo) {
    return (
      <a
        href={"http://maps.google.com/maps?q=" + selectedDevice.geo.lat + "," + selectedDevice.geo.lon}
        target="_blank"
        rel="noopener noreferrer"
        className={"nounderline " + addClassName}
      >
        <i className={useArrowIcon ? "fa fa-location-arrow mr-1" : "fa fa-map mr-1"} />
        {hideIcon ? "" : translate("OpenInGoogleMaps")}
      </a>
    );
  } else return null;
}

export { OpenInGmap };
